"use client";

import { Trans, useTranslation } from "react-i18next";
import { Building2, Users, Hammer, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const networks = [
  { icon: Building2, key: "cities" },
  { icon: Users, key: "associations" },
  { icon: Hammer, key: "thirdPlaces" },
];

const NetworkSection = () => {
  const { t } = useTranslation();

  return (
    <section id="network" className="py-24 bg-muted/40 relative overflow-hidden">
      <div className="absolute -top-20 right-0 w-72 h-72 bg-secondary/10 blob-shape animate-blob-morph blur-3xl" />

      <div className="container mx-auto px-6 relative">
        <div className="text-center mb-16">
          <h2 className="font-heading font-bold text-4xl md:text-5xl mb-4">
            <Trans
              i18nKey="network.title"
              components={{ gradient: <span className="text-gradient" /> }}
            />
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t("network.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {networks.map((n) => (
            <div
              key={n.key}
              className="bg-card border-2 border-border rounded-2xl p-7 card-hover flex flex-col"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 bg-accent/15 text-accent">
                <n.icon className="w-6 h-6" aria-hidden="true" />
              </div>
              <h3 className="font-heading font-bold text-xl mb-3">
                {t(`network.items.${n.key}.title`)}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed mb-6 flex-1">
                {t(`network.items.${n.key}.description`)}
              </p>
              <Button variant="outline" size="sm" className="w-full group">
                {t("network.learnMore")}
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </Button>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-4xl mx-auto bg-card border-2 border-dashed border-border rounded-2xl p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-14 h-14 rounded-2xl bg-primary/15 border-2 border-primary/30 flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-7 h-7 text-primary-foreground" aria-hidden="true" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="font-heading font-bold text-xl mb-1">
              {t("network.others.title")}
            </h3>
            <p className="text-muted-foreground text-sm">
              {t("network.others.description")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkSection;
